import { toZonedTime } from 'date-fns-tz';

import { toastStore } from '../lib/chakraUi/components';
import { TenantGuard } from '../types/tenants';
import { capitalizeFirstLetter } from './general';

export const handleError = (msg: string, title: string = 'Error!'): void => {
  toastStore.create({
    description: msg,
    duration: 9000,
    closable: true,
    type: 'error',
    title,
  });
};

export const handleSuccess = (msg: string, title: string = ''): void => {
  toastStore.create({
    description: msg,
    duration: 9000,
    closable: true,
    type: 'success',
    title: title || 'Success!',
  });
};

export const toDateInClientTimezone = (utcDate: Date | string): Date => {
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return toZonedTime(utcDate, browserTimezone, { timeZone: 'UTC' });
};

export const guardPasses = (
  guard: TenantGuard,
  obj: Record<string, unknown> | null,
): boolean => (obj ? guard(obj) : false);

export const capitalizeFirstLetterAndAddString = (
  inputString: string,
  addedString: string,
) => `${capitalizeFirstLetter(inputString)} ${addedString}`;
